import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { HttpService } from '../../../../services/dataAccess.service';
import { CoreService } from '../../../../services/core.service';
import { PropertyData, HtmlBase, InseeModel, ListInseeQueovalValues, QueovalItem, BObjectModel, BObjectSummary  } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-insee',
  templateUrl: './insee.component.html',
  styleUrls: ['./insee.component.css']
})

export class InseeComponent extends BaseAddOnComponent {

  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
  @Input('input') input: PropertyData;
  @Input('model') set SetModel(value: BObjectModel) { this.model = value; }


  public blocsInsee: Array<ListInseeQueovalValues> = new Array<ListInseeQueovalValues>();
  private queovalValue: Map<string, string> = new Map<string, string>();
  public invalidSiret: boolean = false;

  private model: BObjectModel;
  // #region CONSTRUCTEUR
  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private modalService: NgbModal
  ) { super(); }
  // #endregion

  // #endregion
  public navigToSocieteCom(element: HtmlBase, siret: string): void {
    if (siret.length === 14) {
    const siren: string = siret.slice(0, 9);
    element.OnClick = `${element.OnClick}${siren}`;
      window.open(element.OnClick, '_blank');
    } else {
      this.invalidSiret = true;
    }
  }

  public OpenInseeModal(siret: string, content: any): void {
    if (siret.length === 14) {
      this.indParam.showSplash(true);
      this.http.getHttp<InseeModel>(`${this.indParam.AppParams.apiUrl}api/insee/siret/${siret}`).subscribe((result: InseeModel) => {
        this.blocsInsee = result.ListInseeQueovalValues;
        this.queovalValue = result.ListQueovalValue;
        this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-bo-insee qmodalover' }).result.then((modalResult) => {
          switch (modalResult) {
            //  case 'SAVE': this.saveConfigSignature(); break;
            //  case 'CANCEL': this.closeConfigSignature(); break;
          }
        });
        this.indParam.showSplash(false);
      });
    } else {
      this.invalidSiret = true;
    }
  }

  public ImportInseeParams(modalBoInsee: any): void {
    const keys = Object.keys(this.queovalValue);
    keys.forEach((key: string) => {
      const summary: BObjectSummary[] = this.model.summary.filter((el: BObjectSummary) => {
        return el.ColumnName == key || el.ColumnsIds.includes(key)
      });
      if (summary && summary.length == 1) {
        const prop: PropertyData = this.model.Body.SelectedGroupsList[summary[0].IndexGroupsList].DataList[summary[0].IndexDataList];
        let index: number = prop.MainElementList.findIndex(element => element.ID == key);
        index = index == -1 ? 0 : index;
        if (prop.MainElementList[index].TagName == 'DATEPICKER' || prop.MainElementList[index].TagName == 'DATEHOURPICKER') {
          try {
            const dt: Date = new Date(Date.parse((this.queovalValue as any)[key]));
            prop.MainElementList[index].Value = `${dt.getDate()}/${dt.getMonth() + 1}/${dt.getFullYear()}`;
            this.model.Body.SelectedGroupsList[summary[0].IndexGroupsList].DataList[summary[0].IndexDataList] = JSON.parse(JSON.stringify(prop));
          } catch (ex) {

          }
        }
        prop.MainElementList[index].Value = (this.queovalValue as any)[key];
        if (prop && prop.MainElementList[index].SelectOptionsList && prop.MainElementList[index].SelectOptionsList.length > 0) {
          prop.MainElementList[index].SelectOptionsList.forEach((option: QueovalItem) => {
            if (option.Value == prop.MainElementList[index].Value) {
              option.Selected = true;
            } else {
              option.Selected = false;
            }
          })
        }
      }
    }); 
    modalBoInsee.close('SAVE');
  }
}
